import { useQuery } from '@tanstack/react-query';

import { catalogs } from '@/shared/api/resources';

/** Tamanho maximo da matricula do leiloeiro, o mesmo do servidor (P-NCT-3). */
export const MAX_MATRICULA = 40;

/** A lista de UF do catalogo da plataforma, para a junta comercial. */
export function useUfs() {
  return useQuery({
    queryKey: ['catalogs', 'states'],
    queryFn: ({ signal }) => catalogs.states(signal),
    staleTime: 60 * 60_000,
  });
}
